import React, {Component} from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'material-ui/DatePicker';
import FieldTitle from 'util/FieldTitle';

export const datify = input => {
  if (!input) {
    return null;
  }
  
  const date = input instanceof Date ? input : new Date(input);
  if (isNaN(date)) {
    throw new Error(`Invalid date: ${input}`);
  }
  
  return date;
};

class DateInput extends Component {
  // Convert to date string before dispatching to reducers
  onChange = (value, date) => {
    this.props.input.onChange(`${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`)
  };
  
  updateCurrentDate = () => {
    const current_date = datify(this.props.input.value);
    if (current_date) {
      this.onChange(null, current_date);
    }
  }
  
  componentDidMount() {
    this.updateCurrentDate();
  }
  
  componentDidUpdate() {
    this.updateCurrentDate();
  }
  
  render() {
    const {input, isRequired, label, meta: {touched, error}, options, source, elStyle, resource, minDate, maxDate} = this.props;
    
    return (<DatePicker
      {...input}
      errorText={touched && error}
      floatingLabelText={<FieldTitle label={label} source={source} resource={resource} isRequired={isRequired}/>}
      container="inline"
      autoOk
      value={datify(input.value)}
      onChange={this.onChange}
      style={elStyle}
      minDate={minDate}
      maxDate={maxDate}
      selected={minDate}
      {...options}
    />);
  }
}

DateInput.propTypes = {
  addField: PropTypes.bool.isRequired,
  elStyle: PropTypes.object,
  input: PropTypes.object,
  isRequired: PropTypes.bool,
  label: PropTypes.string,
  meta: PropTypes.object,
  options: PropTypes.object,
  resource: PropTypes.string,
  source: PropTypes.string,
  onBlur: PropTypes.func, // Prevent redux-form onBlur to change DatePicker value
  minDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
};

DateInput.defaultProps = {
  addField: true,
  options: {},
  onBlur: e => e.preventDefault(), // Prevent redux-form onBlur to change DatePicker value
};

export default DateInput;



// WEBPACK FOOTER //
// ./src/components/input/DateInput.js